import EditQuotation from '../../pages/Invoice/EditQuotation';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import constant from '../../utils/constant';
import { QuotationController } from '../../controllers';
import { object, string, number, array, boolean } from 'yup';
import { invoiceStore } from '../../stores';
import { MimaToastUtil } from '../../components';

const EditQuotationContainer = ({ closeModal, quote }) => {
	const [loading, setLoading] = useState(false);

	const invoice = invoiceStore.selectedInvoice;
	const orders = quote?.orders?.map(order => {
		return {
			quantity: order.quantity,
			unitPrice: order.unitPrice,
			item: order.item,
			stock: order.stock,
		};
	});

	const invoiceDetailsValidation = () => {
		return object({
			customer: string().required('Select a customer'),
			orders: array(
				object({
					quantity: number().min(1, 'Quantity should be greater than 1'),
					unitPrice: number().min(1, 'Unit price should be greater than 1'),
					item: string().required('Service is required'),
				})
			),
			currencyCode: string().required('Select Currency'),
			vat: boolean().required('Are you charging VAT?'),
			wht: boolean().required('Are you deducting WHT?'),
			dueDate: string().required('Enter Payment due date'),
			discountPer: number()
				.min(0, 'Min discount should be greater than 0%')
				.max(100, 'Max discount should be less than or equal to 100%'),
			// depositPer: number()
			// 	.min(1, 'Min deposit should be greater than 1%')
			// 	.max(100, 'Max deposit should be less than or equal to 100%')
			// 	.required('Deposit is required'),
		});
	};

	const onSubmit = async values => {
		setLoading(true);
		values.orders.forEach(item => {
			if (item.stock === '') {
				delete item.stock;
			}
			delete item.itemPrice;
			delete item._id;
		});

		const payload = {
			customer: values.customer,
			currencyCode: values.currencyCode,
			note: values.note,
			shipping: values.shipping,
			orders: values.orders,
			discountAmount: values.discountAmount,
			vat: values.vat,
			wht: values.wht,
			dueDate: values.dueDate,
		};

		const { status, errorMessage } = await QuotationController.updateQuotation(
			payload,
			quote._id
		);

		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			closeModal();
		} else {
			setLoading(false);
			MimaToastUtil.error({ message: errorMessage });
		}
	};

	return (
		<EditQuotation
			quote={quote}
			invoice={invoice}
			onSubmit={onSubmit}
			loading={loading}
			orders={orders}
		/>
	);
};

export default observer(EditQuotationContainer);
